import React from 'react'

type LazyImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  /** Optional srcSet for responsive images (e.g. when API/CDN provides multiple sizes). */
  srcSet?: string
  /** Optional sizes attribute for srcSet. */
  sizes?: string
}

/**
 * Image with loading="lazy" and decoding="async" for feeds and reels to improve LCP and bandwidth.
 * Pass srcSet/sizes when the backend provides responsive or WebP URLs.
 */
export default function LazyImage({
  loading = 'lazy',
  decoding = 'async',
  srcSet,
  sizes,
  ...props
}: LazyImageProps) {
  return (
    <img
      loading={loading}
      decoding={decoding}
      srcSet={srcSet}
      sizes={sizes}
      {...props}
    />
  )
}
